import { Link as ChakraLink, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";

export const BottomButtonsSection: React.FC = () => (
  <VStack spacing="10px" pt="2px">
    <ChakraLink as={Link} to="/zapomnialem-hasla" fontSize="14px" color="gray.500" _hover={{ color: "primary", textDecoration: "none" }}>
      Nie pamiętam hasła
    </ChakraLink>
    <Text fontSize="14px" color="gray.500">
      Nie masz konta?{" "}
      <ChakraLink as={Link} to="/rejestracja" color="accent" fontWeight="700" _hover={{ textDecoration: "underline" }}>
        Zarejestruj się
      </ChakraLink>
    </Text>
  </VStack>
);
